import React, { useEffect, useState, useCallback, useMemo } from "react";
import AppointmentCounts from "../components/AppointmentCounts";
import AppointmentFilter from "../components/AppointmentFilter";
import AppointmentTr from "../components/AppointmentTr";
import AppointmentDetailsModal from "../components/AppointmentDetailsModal";
import AppointmentTableHead from "../components/AppointmentTableHead";
import AppointmentMobileCard from "../components/AppointmentMobileCard";
import baseUrl from "../../../../api/baseUrl";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import {
  setMyAppointment,
  setMyAppointmentCount,
} from "../../../../redux/appointment/appointmentAction";
import BottomTab from "../../../../components/pagination/BottomTab";

function YourAppointment() {
  const navigate = useNavigate();
  const [all, setAll] = useState("all");
  const [selectedOption, setSelectedOption] = useState<string>("pending");
  const dispatch = useDispatch();
  const appointment = useSelector((state: RootState) => state.appointment);
  const [counts, setCounts] = useState(0);
  const [detailsItem, setDetailsItem] = useState<any | null>(null);
  const getAppointments = useCallback(
    (status: string, all: string, newPage?: number) => {
      baseUrl
        .get("/appointment/findAllAppointmentDentistId", {
          headers: {
            status: status,
            day: all,
            page: newPage,
          },
        })
        .then((response) => {
          setCounts(response.data.count);
          dispatch(setMyAppointment(response.data.data, false));
        })
        .catch((error) => {
          console.error(error);
        });
    },
    [dispatch]
  );

  const appointmentCount = useCallback(() => {
    baseUrl
      .get("/appointment/appointmentscountsbyId", {
        headers: {
          status: true,
        },
      })
      .then((response) => {
        dispatch(
          setMyAppointmentCount({
            appointments: response.data?.appointments,
            cancelled: response.data?.cancelled,
            completed: response.data?.completed,
            pending: response.data?.pending,
            inqueue: response.data?.inqueue,
            reschudle: response.data?.reschudle,
            ongoing: response.data?.ongoing,
          })
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }, [dispatch]);

  useEffect(() => {
    if (appointment?.myappointmentIsEMpty) getAppointments(selectedOption, all,1);
    if (appointment?.myappointmentIsEMpty) appointmentCount();
  }, [
    getAppointments,
    appointmentCount,
    selectedOption,
    all,
    appointment?.myappointmentIsEMpty,
  ]);

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const status = event.target.value;
    setSelectedOption(status);
    getAppointments(status, all,1);
  };

  const handleDay = (event: React.ChangeEvent<HTMLInputElement>) => {
    const day = event.target.value;
    setAll(day);
    getAppointments(selectedOption, day,1);
  };

  const appointmentRows = useMemo(
    () =>
      appointment?.myappointment?.map((item: any, index: number) => (
        <AppointmentTr
          appointmStatus={() => {
            getAppointments(selectedOption, all);
            appointmentCount();
          }}
          key={index}
          item={item}
        />
      )),
    [appointment, selectedOption, all, getAppointments, appointmentCount]
  );
  const onPageChange = useCallback(
    (newPage: number) => {
      getAppointments(selectedOption, all, newPage);
    },
    [getAppointments, all, selectedOption]
  );

  
  return (
    <div className="min-h-screen">
      <AppointmentCounts count={appointment?.myappointmentCount} />
      <div className="bg-white dark:bg-slate-800 rounded-xl md:rounded-2xl shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-4 md:p-6">
        <AppointmentFilter
          selectedOption={selectedOption}
          all={all}
          handleOptionChange={handleOptionChange}
          handleDay={handleDay}
        />
        {/* Desktop Table */}
        <div className="hidden md:block overflow-hidden rounded-xl border border-slate-200 dark:border-slate-600">
          <table className="w-full">
            <AppointmentTableHead />
            <tbody className="bg-white dark:bg-slate-800 divide-y divide-slate-100 dark:divide-slate-600">{appointmentRows}</tbody>
          </table>
        </div>
        {/* Mobile Cards */}
        <div className="md:hidden space-y-3">
          {appointment?.myappointment?.map((item: any, index: number) => (
            <AppointmentMobileCard
              key={item?._id ?? index}
              item={item}
              onOpenDetails={() => setDetailsItem(item)}
              onStatusChange={() => {
                getAppointments(selectedOption, all);
                appointmentCount();
              }}
              onAddTreatment={(patientId) => {
                baseUrl
                  .post("treatment/create-treatment", { patientId })
                  .then((response) => {
                    navigate(
                      `/client/treatment-diagnose/add-treatment/diagnose/${response.data.data._id}`
                    );
                  })
                  .catch((error) => console.error(error));
              }}
            />
          ))}
          {appointment?.myappointment?.length === 0 && (
            <div className="p-8 text-center text-slate-500 dark:text-slate-400">
              <p className="text-sm">No appointments found</p>
            </div>
          )}
        </div>

        <BottomTab title="Patient" count={counts} onPageChange={onPageChange} />
      </div>

      <AppointmentDetailsModal
        item={detailsItem ?? {}}
        open={detailsItem != null}
        onClose={() => setDetailsItem(null)}
        onStatusChange={() => {
          getAppointments(selectedOption, all);
          appointmentCount();
        }}
      />
    </div>
  );
}

export default YourAppointment;
